export default __webpack_public_path__ + "static/media/15-large.978b5b91.jpg";